export const TABLE_FONT_SIZES = [11, 12, 13, 14, 15, 16, 17];
